import {Typography} from '@mui/material';

export const ServiceTerms = () => {
  return (
    <Typography textAlign="center" variant="h1">
      Terms of Service
    </Typography>
  );
};
